import apiUrl from '../../../constants';
import axios from 'axios';
import {
	Validator
} from 'vee-validate';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import common_helper from '../../../common_helper'
import {nanoid} from 'nanoid';

export default {
	name: 'inward',
	components: {
		vSelect,
		DatePicker,
		VueElementLoading,
		nanoid,
	},
	props: ['selectedRow', 'filterData','searchflag'],

	data: function() {
		return {
			isLoading: false,
			inwardErrors: {},
			result: [],
			inwardaction: '',
			addinwardmodal: false,
			listPOData: [],
			listPOData1:[],
			listInwardData: [],
			listSupplierData: [],
			counter: 0,
			//to close the modal(dependent form field)
			issecondmodal: false,
			poerrors: '',
			Dateerrors: '',
			isDateError: '',
			isError: '',
			referenceNo: '',
			createdbyEmail: '',
			Qtyerrors: '',
			POmapflag: false,
			invoicedate: null,
			modalMessageShowpo: false,
			validate_po_mandate: false,
			emptyPO: '',
			// initialize form field

			addinward: {
				transporter: '',
				invoiceno: '',
				invoicevalue: '',
				noofboxes: '',
				damagedboxes: '',
				damagereasons: '',
				client: '',
				Lr: '',
				vehicleno: '',
				vendor: '',
				materialdesc: '',
				comments: '',
				status: '',
				SKU: '',
				InvoiceQty: '',
				pono: '',
				isSearching: '',
				warehouse: '',
				//merchantid: '',
			},

			listMerchantData: [],
			listClientData: [],
			listWarehouseData: [],
			temp:'',
			merchant: '',
			merchantid: '',
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			clientList: [],
			warehouseList: [],
			merchantList: [],
			ClientErr: '',
			WarehouseErr: '',
			url: null,
     uploadinvoiceflg:false,
		 embedSrc:'',
		 longurl:'',
		 shorturl:'',
		 cancelmodalShow:false,
		}
	},
	computed: {},
	 async mounted  ()  {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		await this.getMerchantList();

		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.createdbyEmail = userdetail.email;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = this.addinward.client = userdetail.clientid;
				this.createdbyEmail = userdetail.email;
				// this.getWarehouseList();
				await this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.warehouseid = this.addinward.warehouse = userdetail.warehouseid;
				this.createdbyEmail = userdetail.email;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods:
	{
		showList() {
		this.modalMessageShowpo = false
		setInterval(() => {
			if((this.searchflag !=undefined && this.searchflag !='') || this.searchflag==false){
				this.$emit("goBackToParent")
			 }
			 else{
				this.$router.push({
					path: '/inwardlist'
				})
			 }
		  }, 400);
	},
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');

		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (result.data.data && result.data.data.length > 0) {
		// 				this.listWarehouseData = result.data.data;
		// 				var warehouseListArray = [];
		// 				result.data.data.forEach(function(item) {
		// 					warehouseListArray[item.warehouseid] = item.warehousename;
		// 				});
		// 				this.warehouseList = warehouseListArray;
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');

		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (result.data.data && result.data.data.length > 0) {
		// 				this.listClientData = result.data.data;

		// 				var clientListArray = [];
		// 				result.data.data.forEach(function(item) {
		// 					clientListArray[item.clientid] = item.clientname;
		// 				});
		// 				this.clientList = clientListArray;
		// 			}
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function(item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
					}
				}, error => {
					console.error(error)
				})
		},
		// clientSelected() {
		// 	this.clientid = this.addinward.client;
		// 	if (this.clientid) {
		// 		this.getMerchantList();
		// 		if (!this.warehouseid) {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.addinward.warehouse;
		// 	if (this.warehouseid) {
		// 		if (!this.clientid) {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		merchantSelected() {
			this.merchantid = this.addinward.vendor;
			if (this.merchantid) {}
		},

		//deletes target records
		removeRow: function(index) {
			this.listPOData1.splice(index, 1);
			this.listPOData.splice(index, 1);
			this.POmapflag = false;
		},

		//on selecting vendor's dropdown option opens the modal(depending form fields)
		addVendor() {
			this.input = ({});
			if (this.addinward.vendor) {
				this.issecondmodal = true;
				this.uploadinvoiceflg = false;
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					clientid: window.localStorage.getItem('selectedClient'),
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getUploadInvoiceValidation',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (result.data.ErrorCode == 0) {
							if(result.data.data[0].value ==='yes'){
								this.uploadinvoiceflg = true;
							}
						}
					}, error => {
						console.error(error)
					})
				this.$validator.reset();
			}
		},

		//closes form modal
		closeAddInwardModal() {
			this.addinwardmodal = false
		},

		validateDate() {
			var currentDate = new Date();
			var InvoiceDate = new Date(this.invoicedate);
			if (Date.parse(InvoiceDate) <= Date.parse(currentDate)) {
				this.isDateError = '';
				this.Dateerrors = '';
			} else {
				this.isDateError = '1';
				this.Dateerrors = ' Invoice date should always be less than or same as current date';
				return false;
			}
		},

		// save form fields in database
		async saveInward() {
			if((this.POmapflag == false) && (this.addinward.pono!='')&&(this.temp==this.addinward.pono)){

				this.$alertify.error("PO Already Mapped to another DR");

                return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.onSubmitForm()) {
				if (this.validate_po_mandate && this.listPOData.length < 1) {
					this.addinward.emptyPO = '1';
					return false;
				} else {
					this.addinward.emptyPO = '';
				}
				let POs = [];
				for (let x = 0; x < this.listPOData.length; x++) {
					POs[x] = {
						srno: (x + 1),
						pono: this.listPOData[x].trim(),
					};
				}
				this.isLoading = true,
					axios({
						method: 'POST',
						'url': apiUrl.api_url + 'SubmitInwardData',
						'data': {
							'clientid': this.clientid,
							'transportername': this.addinward.transporter,
							'lrnumber': this.addinward.Lr,
							'vehicleno': this.addinward.vehicleno,
							'merchantid': this.addinward.vendor,
							'challanno': this.addinward.invoiceno.trim(),
							'invoicevalue': this.addinward.invoicevalue,
							'invoicedate': this.getdate1(this.invoicedate),
							'materialdesc': this.addinward.materialdesc,
							'totalsku': this.addinward.SKU,
							'totalinvoiceqty': this.addinward.InvoiceQty,
							'noofboxes': this.addinward.noofboxes,
							'damagedboxes': this.addinward.damagedboxes == null ? 0 : Number(this.addinward.damagedboxes),
							'comments': this.addinward.comments,
							'warehouseid': window.localStorage.getItem('selectedWarehouse'),
							'createdby': this.createdbyEmail,
							'podetails': POs
						},
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(async (response) => {
						if (response.data.errorCode == 0) {
							this.input = ({
								'drno': response.data.data.challandata['dockreciptnum'],
								'clientid': this.clientid,
							})
							axios({
								method: 'POST',
								'url': apiUrl.api_url + 'elsdr',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							});
							this.referenceNo = response.data.data.challandata['dockreciptnum'];
							if(this.file ){
				        await this.uploadInvoiceDoc();
							}
							this.isLoading = false
							this.$alertify.success(response.data.msg)

							this.modalMessageShowpo = true;
							this.addinwardmodal = false;
							this.POmapflag = false;
							this.listPOData=[];
						} else if (response.data.errorCode == -1) {
							this.isLoading = false
							this.$alertify.error(response.data.msg)
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
		},

		//to search the entered PO
		searchPO() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.addinward.pono.length > 0) {
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'ValidatePO',
						'data': {
							'pono': this.addinward.pono.trim(),
							'warehouseid': window.localStorage.getItem('selectedWarehouse'),
							'merchantid': Number(this.addinward.vendor),
							'clientid': this.clientid
						},
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((response) => {
						this.POCreatedDate = response.data.data.createddate
						//this.addinward.warehouseid = response.data.data.warehouseid;
						//this.addinward.merchantid = response.data.data.merchantid;
						if (response.data.errorCode == 0) {
							this.DateList = response.data.data.deliverbydateterms
							var today = new Date();
							var deliverbydate = new Date(this.DateList);
							if (Date.parse(deliverbydate) >= Date.parse(today)) {
								this.isDateError = '';
								this.Dateerrors = '';
							} else {
								this.isError = '1';
								this.poerrors = 'Invalid delivery date';
							}
							axios({
									method: 'POST',
									'url': apiUrl.api_url + 'ValidateSearchPO',
									'data': {
										'pono': this.addinward.pono.trim(),
										'warehouseid': window.localStorage.getItem('selectedWarehouse'),
										'clientid': this.clientid
									},
									headers: {
										'Authorization': 'Bearer ' + myStr
									}
								})
								.then((response) => {
									if (response.data.errorCode == 0) {
										if (this.POmapflag == false) {
											this.POmapflag = true;
											//doesn't adds duplicates and push the PO result in array
											this.addinward.pono.trim() != '' && this.listPOData.indexOf(this.addinward.pono) == -1 ? this.listPOData.push(this.addinward.pono) : '';
											this.addinward.pono.trim() != '' && this.listPOData1.indexOf(this.addinward.pono) == -1 ? this.listPOData1.push(this.addinward.pono) : '';

											this.temp=this.addinward.pono
											// this.addinward.pono = '',
											this.addinward.emptyPO = ''
											this.isError = '';
											this.poerrors = '';
											this.isDateError = '';
											this.Dateerrors = '';
										} else {
											this.$alertify.error("you can't map more than one PO")
										}
									} else {
										this.isError = '1';
										this.poerrors = 'PO already mapped to another Dock Receipt';
									}
								})
						} else {
							this.isError = '1';
							if(response.data.data[0]){
								if(response.data.data[0].status=='cancelled')
							  	this.poerrors = 'PO cancelled Please choose another PO';
							}else{
								this.poerrors = 'Merchant in PO is different from selected Merchant OR PO does not exist. Please choose another PO';
							}
						}
					})
			} else {
				this.isError = '1';
				this.poerrors = 'Please enter atleast 1 digit';
			}
		},

		showSearch() {
			this.isError = '';
			this.poerrors = '';
			this.isDateError = '';
			this.Dateerrors = '';
		},

		nextInward() {
			location.reload();
		},

		gotoListPage() {
			this.showList()
			this.modalMessageShowpo = false;
		},

		CheckQuantity() {
			if (Number(this.addinward.SKU) > Number(this.addinward.InvoiceQty)) {
				this.isError = '1';
				this.Qtyerrors = 'Quantity must be equal to or greater than SKU';
			} else {
				this.isError = '';
				this.Qtyerrors = '';
			}
		},

		//at cancel button closes the whole model(whole form)
		hidemodal() {
			this.listPOData1 = [];
			this.addinward.client = '';
			// this.addinward = [];
			if(this.user_type!='warehouse_user'){
				this.addinward.warehouse = '';
			}
			this.addinward.client = '';
			this.addinward.vendor = '';
			this.addinward.invoiceno = '';
			this.addinward.invoicevalue = '';
			this.addinward.SKU = '';
			this.addinward.InvoiceQty = '';
			this.addinward.noofboxes = '';
			this.invoicedate = null;
			this.listPOData = [];
			this.listPOData1=[];
			this.$validator.reset();
			this.issecondmodal = false;
			this.POmapflag = false;
			this.addinward.pono = '';
			this.addinward.materialdesc = '';
			this.isError = '';
			this.poerrors = '';
			this.isDateError = '';
			this.Dateerrors = '';
			this.addinward.transporter='';
			this.addinward.Lr=''
			this.addinward.damagedboxes='';
			this.addinward.comments='';
			this.addinward.damagereasons='';
			this.addinward.vehicleno=''
			this.file = null;
			document.getElementById('invoice').value = null
			this.embedSrc = '';
		},

		resetform() {
			this.addinward.materialdesc = '';
			this.addinward.vendor = '';
			this.listPOData = [];
			this.listPOData1 = [];
			this.$validator.reset();
			this.POmapflag = false;
			this.addinward.pono = '';
			this.isError = '';
			this.poerrors = '';
			this.file = null;
			document.getElementById('invoice').value = null
			this.embedSrc = '';
		},
		handleChange(){
			this.inwardErrors.invoice = '';
			this.file = this.$refs.file.files[0];
			let fileTypes = ['application/pdf']
			let fileFormat = this.file.type
			let checkFormat = fileTypes.includes(fileFormat)
			if (!checkFormat) {
				this.file = null
				document.getElementById('invoice').value = null
				this.$alert("Invalid file format")
			}
			if (this.file) {
				var path = document.getElementById('invoice');
				if (!path.value == "") {
					var pdf = path.files[0].size;
					var pdfsize = pdf / 1024;
					if (pdfsize > 51200) {
						this.$alert("Pdf size cannot be uploaded greater than 50mb size")
						document.getElementById('invoice').value = null
						this.file=null
						return false;
					}
				}
			}
			// if(this.embedSrc){
			// 	this.previousfile = this.embedSrc;
      //   this.cancelmodalShow = true;
			// }
	 		this.embedSrc = URL.createObjectURL(event.target.files[0]);
		},
		preView(){
			window.open(this.embedSrc)
		},
		async uploadInvoiceDoc(){
			return new Promise(async(resolve, reject) => {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				 if (!this.file) {
					this.$alert("Select File")
					return false
				}
				if (this.file) {
					var path = document.getElementById('invoice');
					if (!path.value == "") {
						var pdf = path.files[0].size;
						var pdfsize = pdf / 1024;
						if (pdfsize > 51200) {
							this.$alert("Pdf size cannot be uploaded greater than 50mb size")
							document.getElementById('invoice').value = null
							this.file=null
							return false;
						}
					}
				}
				
				this.isLoading = true
				
				var selectedFile = document.getElementById("invoice").files;
				var fileToLoad = selectedFile[0];
		
				let reader = new FileReader()
				reader.readAsDataURL(fileToLoad)
				let pdfStream = await new Promise((resolve, reject) => {
					reader.onload = function () {
						this.base64String = reader.result.replace("", "")
						resolve(this.base64String)
					}
				})

				let result = await axios({
					'method': 'POST',
					'url': apiUrl.api_url + 'uploadfile',
					'data': {
					  body: pdfStream,
					  key: 'dr/invoice/'+this.referenceNo+'.pdf'
					},
					'headers': {
					  'Authorization': 'Bearer ' + myStr,
					}
				  })
					.then(async (response) => {
						this.longurl = response.data.url;
						this.shorturl = nanoid(10);
						let inputpayload2 = {
							clientid:this.clientid,
							warehouseid:window.localStorage.getItem('selectedWarehouse'),
							drno :this.referenceNo,
							longurl : this.longurl,
							shorturl:this.shorturl
						};
					 let saveUrl = await common_helper.getRestApiResponse('POST', 'saveInvoiceUrl', inputpayload2,this.$alertify)
						 if(saveUrl){
							 //this.isLoading = false;
							 resolve(saveUrl)
						 }
						 //this.isLoading = false;
					})
					//this.isLoading = false;
		})
		},
		getdate1(date) {
			var today = new Date(date);
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = '0' + dd;
			}
			if (mm < 10) {
				mm = '0' + mm;
			}
			var today = yyyy + '-' + mm + '-' + dd;
			return today;
		},

		//validate all form fields on onsubmit()
		onSubmitForm() {
			this.inwardErrors = {};

			if (window.localStorage.getItem('selectedClient')==='undefined')
				this.$alertify.error('Please Select Client')
			if (window.localStorage.getItem('selectedWarehouse')==='undefined')
			    this.$alertify.error('Please Select Warehouse')
			if (!this.addinward.vendor)
				this.inwardErrors.vendor = this.$t('common.merchantError');
			if(!this.addinward.transporter)
				this.inwardErrors.transporter=this.$t('inwardList.inward.transporterError')
			if(!this.addinward.Lr)
				this.inwardErrors.Lr=this.$t('inwardList.inward.LrError')
			if(!this.addinward.vehicleno)
				this.inwardErrors.vehicleno=this.$t('inwardList.inward.vehiclenoError')
			if (!this.addinward.invoiceno)
				this.inwardErrors.invoiceno = this.$t('inwardList.inward.invoiceNoError');
			if (!this.addinward.invoicevalue)
				this.inwardErrors.invoicevalue = this.$t('inwardList.inward.invoiceValueError');
			if (!this.invoicedate)
				this.inwardErrors.invoicedate = this.$t('inwardList.inward.invoiceDateError');
			if (!this.addinward.SKU)
				this.inwardErrors.SKU = this.$t('inwardList.inward.totalSKUError');
			if (!this.addinward.InvoiceQty)
				this.inwardErrors.InvoiceQty = this.$t('inwardList.inward.totalInvoiceQuantityError');
			if (!this.addinward.noofboxes)
				this.inwardErrors.noofboxes = this.$t('inwardList.inward.noOfBoxesError');
				console.log(this.uploadinvoiceflg+'   '+this.file);
			if((this.uploadinvoiceflg) && (!this.file))
		  	this.inwardErrors.invoice = "Please Upload File";

			// if (!this.addinward.pono)
			// 	this.inwardErrors.pono = 'Please select pono';
			if (Object.keys(this.inwardErrors).length == 0) {
				return true;
			} else {
				return false;
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/inward/inward.component.js